<template>
  <v-container fluid="">
    <v-card>
      <v-toolbar>
        <svg-path-icon name="caja"></svg-path-icon>

        <v-toolbar-title class="font-weight-light">
          <v-row align="center">
            <v-col> &nbsp;Módulo de Caja y Cobranzas / </v-col>
            <v-col v-if="showSelector">
              <v-autocomplete
                v-model="cajaId"
                :items="listCajas"
                item-text="descripcion"
                item-value="id"
                label=""
                no-data-text="Seleccione una Caja"
                hide-details
                placeholder="Seleccione una"
                :menu-props="{ minWidth: '300' }"
              >
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.descripcion"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.empresaNombre"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <!-- <v-col>
                        <v-chip v-if="selectedCaja" :color="selectedCaja.empresaColor" dark label>
                            Caja de {{selectedCaja.empresaNombre}}
                        </v-chip>                        
                    </v-col> -->
            <v-col v-if="selectedCaja && cajaAbierta && !showSelector">
              <span class="font-weight-medium">
                {{ selectedCaja ? selectedCaja.descripcion : '' }}
              </span>
            </v-col>
            <v-col v-if="selectedCaja && cajaAbierta && !showSelector">
              Fecha:
              <span class="font-weight-medium">
                {{ this.$moment(this.fechaCaja).format('DD-MM-YYYY') }}
              </span>
            </v-col>

            <v-col v-if="!showSelector">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    icon
                    small
                    color="green"
                    v-on="on"
                    top
                    @click="cambiarCaja"
                  >
                    <v-icon>sync_alt</v-icon>
                  </v-btn>
                </template>
                <span>Cambiar de Caja</span>
              </v-tooltip>
            </v-col>

            <v-col v-if="showSelector">
              <span
                class="body-1"
                v-if="selectedCaja && selectedCaja && selectedCaja.id > 0"
              >
                (se encuentra
                {{
                  selectedCaja
                    ? selectedCaja.estaAbierta
                      ? 'abierta para el ' +
                        this.$moment(selectedCaja.abiertaEl).format(
                          'DD-MM-YYYY'
                        )
                      : 'cerrada'
                    : ''
                }})&nbsp;</span
              >

              <v-tooltip
                bottom
                v-if="cajaAbierta && selectedCaja && selectedCaja.id > 0"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    outlined
                    color="green"
                    v-on="on"
                    top
                    @click="
                      showSelectorCajas = false;
                      fechaCaja = selectedCaja.abiertaEl;
                      seleccionarCaja();
                    "
                  >
                    Seleccionar&nbsp;
                  </v-btn>
                </template>
                <span>Seleccionar la Caja para Operar</span>
              </v-tooltip>

              <v-tooltip
                bottom
                v-if="
                  !cajaAbierta &&
                    selectedCaja &&
                    selectedCaja.id > 0 &&
                    !abrirOtraFecha
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    outlined
                    color="green"
                    v-on="on"
                    top
                    @click="abrirCaja(true)"
                  >
                    Abrir&nbsp;
                  </v-btn>
                </template>
                <span>Abrir Hoy</span>
              </v-tooltip>

              <v-tooltip
                bottom
                v-if="
                  !cajaAbierta &&
                    selectedCaja &&
                    selectedCaja.id > 0 &&
                    !abrirOtraFecha &&
                    cambiarFechaCaja
                "
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    icon
                    small
                    color="orange"
                    v-on="on"
                    top
                    @click="abrirOtraFecha = true"
                  >
                    <v-icon>date_range</v-icon>
                  </v-btn>
                </template>
                <span>Abrir en Otra Fecha</span>
              </v-tooltip>
            </v-col>

            <v-col v-if="showSelector && abrirOtraFecha">
              <v-text-field
                v-model="fechaCaja"
                label="Abrir Caja El"
                type="date"
                prepend-icon="event"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col v-if="showSelector && abrirOtraFecha">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    outlined
                    color="green"
                    v-on="on"
                    top
                    @click="abrirCaja(false)"
                  >
                    Abrir&nbsp;
                  </v-btn>
                </template>
                <span>Abrir</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              dark
              outlined
              color="brown"
              v-on="on"
              @click="showConfigTickeadora = true"
            >
              Configurar Caja<v-icon>local_movies</v-icon>
            </v-btn>
          </template>
          <span>Configurar parámetros de Caja</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>

      <v-container fluid v-if="sinConfiguracionLocal">
        <v-alert type="error">
          Atención, parece ser tu primer ingreso a la caja. Es necesario
          configurar algunos datos. Por favor, presione el boton Configurar Caja
          (arriba a la derecha) para proceder.
        </v-alert>
      </v-container>

      <v-container
        fluid
        v-if="apiSerialPrintConfigurada && !apiSerialPrintValidada"
      >
        <v-alert type="info">
          Atención, no se pudo verificar el funcionamiento de la Api de
          Impresión. Presione el botón Verificar Api de Impresión (en Acciones
          Puntuales)
        </v-alert>
      </v-container>

      <!-- lista de movimientos -->
      <v-row v-if="cajaAbierta && !showSelector">
        <v-col
          cols="9"
          v-if="$store.state.parametrosGenerales.cajaMostrarMovimientosDelDia"
        >
          <template v-for="(itemMovimientos, i) in listMovimientosDia">
            <v-container
              fluid
              :key="i"
              v-if="
                itemMovimientos.moneda.predeterminada ||
                  showMovimientosMonedaExtranjera
              "
            >
              <v-row dense align="center">
                <v-col>
                  <!-- <v-chip  label color="green" dark v-if="selectedCaja.multiMoneda == true"> Movimientos del Día en {{ itemMovimientos.moneda.descripcion}} </v-chip> -->
                  <span v-if="selectedCaja.multiMoneda == true">
                    Movimientos del Día en
                    <span class="green--text font-weight-bold">
                      {{ itemMovimientos.moneda.descripcion }}
                    </span>
                  </span>
                  <span v-else> Movimientos del Día </span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <v-text-field
                    v-model="filtroComentariosMovimiento"
                    label="Filtrar por Comentarios"
                    append-icon="search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-data-table
                    :headers="headersMovimientosDia"
                    :items="itemMovimientos.listMovimientosDia"
                    :loading="loading"
                    :server-items-length="itemMovimientos.totalItems"
                    :rows-per-page="itemMovimientos.pagination.rowsPerPage"
                    :options.sync="itemMovimientos.pagination"
                    dense
                  >
                    <template v-slot:no-data>
                      <v-alert :value="true" icon="warning">
                        No hay movimientos en el día
                      </v-alert>
                    </template>

                    <template v-slot:item="{ item }">
                      <tr
                        v-if="
                          $store.state.parametrosGenerales
                            .cajaMostrarSaldoActual ||
                            item.concepto != 'SALDO ACTUAL'
                        "
                        :class="
                          item.concepto == 'SALDO ACTUAL'
                            ? 'grey white--text'
                            : ''
                        "
                      >
                        <td class="text-xs-left caption">
                          {{ item.concepto }}
                        </td>

                        <td class="text-xs-left caption">
                          {{ itemMovimientos.moneda.simbolo }}
                          {{ item.importe.toFixed(2) }}
                        </td>
                        <td class="text-xs-left caption">{{ item.info }}</td>
                        <td
                          class="text-xs-left caption"
                          v-if="
                            item.concepto != 'SALDO ACTUAL' &&
                              item.concepto != 'SALDO INICIO'
                          "
                        >
                          {{ item.transaccionId.substring(0, 8) }}...
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                x-small
                                v-on="on"
                                @click="copyTextToClipboard(item.transaccionId)"
                                >info</v-icon
                              >
                            </template>
                            <span
                              >{{
                                item.transaccionId + ' (Haga click para copiar)'
                              }}
                            </span>
                          </v-tooltip>
                        </td>
                        <td class="text-xs-left caption" v-else></td>
                        <td
                          v-if="
                            modoAnulacion &&
                              item.concepto != 'SALDO ACTUAL' &&
                              item.concepto != 'SALDO INICIO'
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                x-small
                                color="red"
                                v-on="on"
                                @click="anular(item)"
                                >highlight_off</v-icon
                              >
                            </template>
                            <span>Anular Movimiento</span>
                          </v-tooltip>
                        </td>
                        <td
                          v-if="
                            modoReimpresion &&
                              item.concepto != 'SALDO ACTUAL' &&
                              item.concepto != 'SALDO INICIO'
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                x-small
                                color="orange"
                                v-on="on"
                                @click="imprimir(item)"
                                >print</v-icon
                              >
                            </template>
                            <span>Reimprimir</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <v-container
            v-if="
              !showMovimientosMonedaExtranjera &&
                listMovimientosDia.length > 1 &&
                listMovimientosDia[1].listMovimientosDia.length > 2
            "
          >
            <v-chip color="info" label
              >Atención: Hay movimientos del Día en Otras Monedas</v-chip
            >
          </v-container>
        </v-col>

        <!-- acciones puntuales   -->
        <v-col cols="3" class="text-right">
          <v-container fluid>
            <!-- <v-row no-gutters >
                            <v-col>
                                <span> {{selectedCaja? selectedCaja.descripcion: ""}}</span>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col>
                                <span> en Sucursal CENTRAL</span>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider> -->
            <v-row class="text-right">
              <v-col>
                <span class="body-1"> Acciones Puntuales</span>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters>
              <v-col>
                <v-btn small text color="indigo" @click="altaMovimientoPuntual">
                  Alta de Movimiento <v-icon>note_add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-btn small text color="brown" @click="cerrarCaja">
                  Cierre de Caja <v-icon>lock</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-btn small text color="blue" @click="listadosCaja(true)">
                  Listados <v-icon>file_copy</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters v-if="anularMovimiento">
              <v-col>
                <v-btn
                  small
                  text
                  color="red"
                  @click="modoAnulacion = !modoAnulacion"
                >
                  Anular Movimientos <v-icon>highlight_off</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-row no-gutters>
              <v-col>
                <v-btn
                  small
                  text
                  color="orange"
                  @click="modoReimpresion = !modoReimpresion"
                >
                  Re-Imprimir Transacción <v-icon>print</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters v-if="$store.state.debugModeOn">
              <v-col>
                <v-btn small text color="info" @click="validarApiSerialPrint">
                  Validar Api Impresión <v-icon>print</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters v-if="localConfig.usarTickeadora">
              <v-col>
                <div class="caption">
                  Api: {{ localConfig.apiSerialPrint }} en
                  {{ localConfig.port }}
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <!-- <v-row no-gutters v-if="$store.state.debugModeOn">
                            <v-col>
                                <v-btn small text  color="red"  @click="print2com">
                                    Test Print2Com <v-icon >highlight_off</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row> -->
            <v-row no-gutters v-if="selectedCaja.multiMoneda">
              <v-col>
                <v-btn
                  small
                  text
                  color="green"
                  @click="
                    showMovimientosMonedaExtranjera = !showMovimientosMonedaExtranjera
                  "
                >
                  Mostrar Movimientos Otras Monedas
                  <v-icon>attach_money</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <!-- selección de persona -->
      <v-container fluid pa-6 v-if="cajaAbierta && !showSelector">
        <v-row v-if="!selectedPersona" dense>
          <v-col cols="10">
            <v-alert
              color="warning"
              dense
              border="bottom"
              colored-border
              elevation="2"
            >
              <span class="subtitle-1"
                >Seleccione a una Persona para realizar una Cobranza o
                Egreso</span
              >
            </v-alert>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2">
            <v-alert
              dark
              :color="selectedCaja.empresaColor"
              dense
              border="bottom"
              elevation="2"
            >
              <span class="subtitle-1">
                Caja de {{ selectedCaja.empresaNombre }}</span
              >
            </v-alert>
          </v-col>
        </v-row>

        <v-row align="center" v-if="!selectedPersona">
          <app-busqueda-personas
            :personaSeleccionada="setPersona"
          ></app-busqueda-personas>
        </v-row>

        <v-row v-if="selectedPersona">
          <v-col cols="10">
            <v-alert
              :color="selectedCaja.empresaColor"
              dense
              border="bottom"
              colored-border
              elevation="2"
            >
              <span class="subtitle-1">Persona Seleccionada</span>
            </v-alert>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2">
            <v-alert
              dark
              :color="selectedCaja.empresaColor"
              dense
              border="bottom"
              elevation="2"
            >
              <span class="subtitle-1">
                Caja de {{ selectedCaja.empresaNombre }}</span
              >
            </v-alert>
          </v-col>
        </v-row>

        <v-row align="center" v-if="selectedPersona">
          <v-col cols="2">
            <v-text-field
              v-model="selectedPersona.cui"
              label="CUI(L/T) "
              key="cuil"
              :disabled="true"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="selectedPersona.nombreCompleto"
              label="Nombre"
              :disabled="true"
            ></v-text-field>
          </v-col>

          <v-col cols="1">
            <v-btn color="brown" dark small @click="limpiar">Cambiar</v-btn>
          </v-col>
          <v-col cols="1">
            <app-acciones-comunes
              :documento="selectedPersona.cui.toString().substring(2, 10)"
              :personaId="selectedPersona.personaId"
            >
            </app-acciones-comunes>
          </v-col>

          <v-chip
            v-if="
              selectedPersona != null &&
                selectedPersona.alertas &&
                selectedPersona.alertas.length > 0
            "
            small
            color="red"
            dark
            @click="showAlertas = true"
            >Ver Alertas</v-chip
          >
        </v-row>
        <v-row align="center" v-if="selectedPersona">
          <v-col>
            <v-btn-toggle v-model="accion">
              <v-btn
                color="success"
                small
                text
                value="cobranza"
                @click="loadDeudasPorCobrar"
                >Realizar Una Cobranza</v-btn
              >
              <v-btn
                color="info"
                small
                text
                value="egreso"
                @click="loadCreditosPorLiquidar"
                >Realizar Un Desembolso de Crédito</v-btn
              >
              <v-btn
                color="warning"
                small
                text
                value="altaCargo"
                @click="altaCargo"
                v-if="puedeAltaNuevoCargo"
                >Alta Nuevo Cargo</v-btn
              >
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row> </v-row>
      </v-container>

      <!-- cobranza -->
      <v-container fluid v-if="accion == 'cobranza'">
        <v-card>
          <v-card-title>
            <span class="title">Alta de Cobranza</span>
            <v-spacer></v-spacer>

            <v-alert dark color="lime" dense v-if="enEstudio">
              <span class="subtitle-1">En Estudio</span>
            </v-alert>
          </v-card-title>

          <v-card-subtitle v-if="puedeModificarFechaValor">
            <v-row>
              <v-col cols="3">
                <v-checkbox
                  v-model="modificarFechaValor"
                  label="Modificar Fecha Valor"
                ></v-checkbox>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-if="modificarFechaValor"
                  v-model="fechaProceso"
                  label="Fecha Valor"
                  type="date"
                  prepend-icon="event"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-subtitle>

          <v-row>
            <v-col cols="8">
              <v-card>
                <v-card-title>
                  <span v-if="!loadingDeudas">Deudas de la Persona</span>

                  <span v-if="loadingDeudas" class="green--text">
                    (Consultando Deudas de la Persona...
                    <v-progress-circular
                      indeterminate
                      size="24"
                      color="green"
                    ></v-progress-circular
                    >)</span
                  >

                  <v-tooltip bottom v-if="listDeudasNoPuedeCobrar.length > 0">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="warning"
                        dark
                        v-on="on"
                        @click="showDeudasNoDisponibles = true"
                        >info</v-icon
                      >
                    </template>
                    <span
                      >Hay deudas que no pueden ser cobradas. Click para más
                      información.
                    </span>
                  </v-tooltip>
                </v-card-title>

                <!-- créditos por cobrar -->
                <v-container fluid v-if="listCreditosPorCobrar.length > 0">
                  <v-row class="body-2" dense>
                    <v-col> Crédito </v-col>
                    <v-col> Deuda a la Fecha </v-col>
                    <v-col cols="1"> </v-col>
                  </v-row>

                  <v-divider></v-divider>

                  <template v-for="(item, index) in listCreditosPorCobrar">
                    <v-row :key="index" dense>
                      <v-container fluid>
                        <v-row class="caption" no-gutters>
                          <v-col>
                            Nº {{ item.numero }}, de {{ item.origen }}
                            {{ item.tipo }}
                          </v-col>
                          <v-col cols="1">
                            <v-chip
                              label
                              small
                              :color="item.empresaColor"
                              dark
                              >{{ item.empresaShort }}</v-chip
                            >
                          </v-col>

                          <v-col>
                            {{ item.deudaALaFecha }}
                          </v-col>
                          <v-col
                            cols="1"
                            v-if="
                              item.detalle
                                .map((i) => i.importePunitorios)
                                .reduce((a, b) => a + b, 0) > 0
                            "
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  small
                                  label
                                  dark
                                  color="orange"
                                  v-on="on"
                                  @click="
                                    imprimirReconocimientoPunitorios(item)
                                  "
                                >
                                  <v-icon small>print</v-icon>
                                </v-btn>
                              </template>
                              <span>Imprimir Reconocimiento de Punitorios</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <v-btn
                              small
                              text
                              color="green"
                              @click="pagarTotalDeudaCredito(item)"
                            >
                              Pagar Deuda Vencida ({{
                                item.importe | currency
                              }})
                            </v-btn>
                            &nbsp;
                            <v-btn
                              small
                              text
                              color="indigo"
                              @click="
                                creditoSeleccionadoId = item.id;
                                showDetalleCredito = true;
                              "
                            >
                              Pagar un Monto Distinto
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row v-if="isExpandedDetalleCredito(item)">
                          <v-col cols="12">
                            <v-container>
                              <v-card outlined>
                                <v-card-text>
                                  <v-row>
                                    <v-col>
                                      <span
                                        class="caption blue--text font-weight-medium"
                                        >Detalle de Deuda del Crédito Nº
                                        {{ item.numero }}</span
                                      >
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters>
                                    <v-col cols="3">
                                      <span class="caption">Cuota</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption">Saldo Cta.</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption">Punitorios</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption">Cargos</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption">Saldo Total</span>
                                    </v-col>

                                    <v-col cols="1">
                                      <span class="caption"></span>
                                    </v-col>
                                  </v-row>
                                  <v-divider></v-divider>
                                  <template
                                    v-for="(subitem, subindex) in item.detalle"
                                  >
                                    <v-row :key="subindex" no-gutters>
                                      <v-col cols="3">
                                        <div
                                          v-if="
                                            subitem.vencido &&
                                              !subitem.numero.includes('Nota')
                                          "
                                          class="caption red--text"
                                        >
                                          {{ subitem.numero }}, Vto.
                                          {{
                                            subitem.vencimiento
                                              | dateParse()
                                              | dateFormat('DD-MM-YY')
                                          }}
                                        </div>
                                        <div
                                          v-if="
                                            subitem.vencido &&
                                              subitem.numero.includes('Nota')
                                          "
                                          class="caption red--text"
                                        >
                                          {{ subitem.numero }}
                                        </div>
                                        <div
                                          v-if="
                                            !subitem.vencido &&
                                              !subitem.numero.includes('Nota')
                                          "
                                          class="caption"
                                        >
                                          {{ subitem.numero }}, Vto.
                                          {{
                                            subitem.vencimiento
                                              | dateParse()
                                              | dateFormat('DD-MM-YY')
                                          }}
                                        </div>
                                        <div
                                          v-if="
                                            !subitem.vencido &&
                                              subitem.numero.includes('Nota')
                                          "
                                          class="caption"
                                        >
                                          {{ subitem.numero }}
                                        </div>
                                      </v-col>
                                      <v-col cols="2">
                                        <div
                                          v-if="subitem.vencido"
                                          class="caption red--text"
                                        >
                                          {{ subitem.importeCuota | currency }}
                                        </div>
                                        <div v-else class="caption">
                                          {{ subitem.importeCuota | currency }}
                                        </div>
                                      </v-col>
                                      <v-col cols="2">
                                        <div
                                          v-if="subitem.vencido"
                                          class="caption red--text"
                                        >
                                          {{
                                            subitem.importePunitorios | currency
                                          }}
                                        </div>
                                        <div v-else class="caption">
                                          {{
                                            subitem.importePunitorios | currency
                                          }}
                                        </div>
                                      </v-col>
                                      <v-col cols="2">
                                        <div
                                          v-if="subitem.vencido"
                                          class="caption red--text"
                                        >
                                          {{ subitem.importeCargos | currency }}
                                        </div>
                                        <div v-else class="caption">
                                          {{ subitem.importeCargos | currency }}
                                        </div>
                                      </v-col>
                                      <v-col cols="2">
                                        <div
                                          v-if="subitem.vencido"
                                          class="caption red--text"
                                        >
                                          {{ subitem.importeTotal | currency }}
                                        </div>
                                        <div v-else class="caption">
                                          {{ subitem.importeTotal | currency }}
                                        </div>
                                      </v-col>
                                      <v-col cols="1">
                                        <div class="caption">
                                          <v-icon
                                            v-if="
                                              listDeudasAPagar.find(
                                                (i) =>
                                                  i.cuotaId == subitem.id &&
                                                  i.notaDebitoId ==
                                                    subitem.notaDebitoId
                                              ) == null
                                            "
                                            color="green"
                                            @click="
                                              agregarCuotaCredito(
                                                item.id,
                                                subitem
                                              )
                                            "
                                            >add</v-icon
                                          >
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <v-divider></v-divider>
                                  <v-row no-gutters>
                                    <v-col cols="3">
                                      <span class="caption font-weight-bold"
                                        >TOTALES</span
                                      >
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption font-weight-bold">{{
                                        totalImporteCuotas(item.detalle)
                                          | currency
                                      }}</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption font-weight-bold">{{
                                        totalImportePunitorios(item.detalle)
                                          | currency
                                      }}</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption font-weight-bold">{{
                                        totalImporteCargos(item.detalle)
                                          | currency
                                      }}</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption font-weight-bold">{{
                                        totalImporteSaldo(item.detalle)
                                          | currency
                                      }}</span>
                                    </v-col>

                                    <v-col cols="1">
                                      <span class="caption"></span>
                                    </v-col>
                                  </v-row>

                                  <v-row align="center">
                                    <v-col cols="3">
                                      <v-switch
                                        v-model="modoExcepcion"
                                        label="Excepción"
                                      ></v-switch>
                                    </v-col>
                                    <v-col cols="2" v-if="!modoExcepcion">
                                      <v-text-field
                                        label="Total a Aplicar"
                                        v-model="totalAplicarCuota"
                                        v-on:keyup="
                                          totalAAplicarKeyUp($event, item)
                                        "
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="2" v-if="modoExcepcion">
                                      <v-text-field
                                        label="Aplicar a Cuota"
                                        v-model="totalAplicarCuota"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="2" v-if="modoExcepcion">
                                      <v-text-field
                                        label="Aplicar a Punit."
                                        v-model="totalAplicarPunitorios"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="2" v-if="modoExcepcion">
                                      <v-text-field
                                        label="Aplicar a Cargos"
                                        v-model="totalAplicarCargos"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                      v-if="
                                        (modoExcepcion &&
                                          parseFloat(totalAplicarCuota) +
                                            parseFloat(totalAplicarPunitorios) +
                                            parseFloat(totalAplicarCargos) >
                                            0) ||
                                          (!modoExcepcion &&
                                            totalAplicarCuota > 0)
                                      "
                                    >
                                      <v-btn
                                        color="green"
                                        fab
                                        x-small
                                        @click="
                                          agregarCuotasPorMonto(
                                            item.id,
                                            'Credito'
                                          )
                                        "
                                      >
                                        <v-icon>add</v-icon></v-btn
                                      >
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-container>
                          </v-col>
                        </v-row>
                        <v-row dense> &nbsp; </v-row>
                        <v-divider pa-6></v-divider>
                      </v-container>
                    </v-row>
                  </template>
                </v-container>

                <!-- acuerdos por cobrar -->
                <v-container fluid v-if="listAcuerdosPorCobrar.length > 0">
                  <v-row class="body-2" dense>
                    <v-col> Acuerdo </v-col>
                    <v-col> Deuda a la Fecha </v-col>
                  </v-row>

                  <v-divider></v-divider>

                  <template v-for="(item, index) in listAcuerdosPorCobrar">
                    <v-row :key="index" dense>
                      <v-container fluid>
                        <v-row class="caption" no-gutters>
                          <v-col>
                            ACUERDO DE PAGO &nbsp;
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  color="success"
                                  dark
                                  v-on="on"
                                  @click="loadDeudasAcuerdo(item)"
                                  >info</v-icon
                                >
                              </template>
                              <span>Ver deudas incluidas en el Acuerdo</span>
                            </v-tooltip>
                          </v-col>
                          <v-col>
                            {{ item.deudaALaFecha }} {{ item.motivo }}
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <v-btn
                              small
                              text
                              color="green"
                              @click="pagarTotalDeudaCredito(item)"
                            >
                              Pagar la Totalidad ({{ item.importe | currency }})
                            </v-btn>
                            &nbsp;
                            <v-btn
                              small
                              text
                              color="indigo"
                              @click="
                                creditoSeleccionadoId = item.id;
                                showDetalleCredito = true;
                              "
                            >
                              Pagar un Monto Distinto
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row v-if="isExpandedDetalleCredito(item)">
                          <v-col cols="12">
                            <v-container>
                              <v-card outlined>
                                <v-card-text>
                                  <v-row>
                                    <v-col>
                                      <span
                                        class="caption blue--text font-weight-medium"
                                        >Detalle de Deuda del Acuerdo</span
                                      >
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters>
                                    <v-col cols="3">
                                      <span class="caption">Cuota</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption">Saldo Cta.</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption">Punitorios</span>
                                    </v-col>
                                    <!-- <v-col cols="2">
                                                                        <span class="caption">Cargos</span>
                                                                    </v-col> -->
                                    <v-col cols="2">
                                      <span class="caption">Saldo Total</span>
                                    </v-col>

                                    <v-col cols="1">
                                      <span class="caption"></span>
                                    </v-col>
                                  </v-row>
                                  <v-divider></v-divider>
                                  <template
                                    v-for="(subitem, subindex) in item.detalle"
                                  >
                                    <v-row :key="subindex" no-gutters>
                                      <v-col cols="3">
                                        <div
                                          v-if="
                                            subitem.vencido &&
                                              !subitem.numero.includes('Nota')
                                          "
                                          class="caption red--text"
                                        >
                                          {{ subitem.numero }}, Vto.
                                          {{
                                            subitem.vencimiento
                                              | dateParse()
                                              | dateFormat('DD-MM-YY')
                                          }}
                                        </div>
                                        <div
                                          v-if="
                                            subitem.vencido &&
                                              subitem.numero.includes('Nota')
                                          "
                                          class="caption red--text"
                                        >
                                          {{ subitem.numero }}
                                        </div>
                                        <div
                                          v-if="
                                            !subitem.vencido &&
                                              !subitem.numero.includes('Nota')
                                          "
                                          class="caption"
                                        >
                                          {{ subitem.numero }}, Vto.
                                          {{
                                            subitem.vencimiento
                                              | dateParse()
                                              | dateFormat('DD-MM-YY')
                                          }}
                                        </div>
                                        <div
                                          v-if="
                                            !subitem.vencido &&
                                              subitem.numero.includes('Nota')
                                          "
                                          class="caption"
                                        >
                                          {{ subitem.numero }}
                                        </div>
                                      </v-col>
                                      <v-col cols="2">
                                        <div
                                          v-if="subitem.vencido"
                                          class="caption red--text"
                                        >
                                          {{ subitem.importeCuota | currency }}
                                        </div>
                                        <div v-else class="caption">
                                          {{ subitem.importeCuota | currency }}
                                        </div>
                                      </v-col>
                                      <v-col cols="2">
                                        <div
                                          v-if="subitem.vencido"
                                          class="caption red--text"
                                        >
                                          {{
                                            subitem.importePunitorios | currency
                                          }}
                                        </div>
                                        <div v-else class="caption">
                                          {{
                                            subitem.importePunitorios | currency
                                          }}
                                        </div>
                                      </v-col>
                                      <!-- <v-col cols="2">
                                                                            <div v-if="subitem.vencido" class="caption red--text">{{subitem.importeCargos| currency}}</div>
                                                                            <div v-else class="caption">{{subitem.importeCargos| currency}}</div>
                                                                        </v-col> -->
                                      <v-col cols="2">
                                        <div
                                          v-if="subitem.vencido"
                                          class="caption red--text"
                                        >
                                          {{ subitem.importeTotal | currency }}
                                        </div>
                                        <div v-else class="caption">
                                          {{ subitem.importeTotal | currency }}
                                        </div>
                                      </v-col>
                                      <v-col cols="1">
                                        <div class="caption">
                                          <v-icon
                                            v-if="
                                              listDeudasAPagar.find(
                                                (i) =>
                                                  i.cuotaId == subitem.id &&
                                                  i.notaDebitoId ==
                                                    subitem.notaDebitoId
                                              ) == null
                                            "
                                            color="green"
                                            @click="
                                              agregarCuotaAcuerdo(
                                                item.id,
                                                subitem
                                              )
                                            "
                                            >add</v-icon
                                          >
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <v-divider></v-divider>
                                  <v-row no-gutters>
                                    <v-col cols="3">
                                      <span class="caption font-weight-bold"
                                        >TOTALES</span
                                      >
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption font-weight-bold">{{
                                        totalImporteCuotas(item.detalle)
                                          | currency
                                      }}</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption font-weight-bold">{{
                                        totalImportePunitorios(item.detalle)
                                          | currency
                                      }}</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption font-weight-bold">{{
                                        totalImporteCargos(item.detalle)
                                          | currency
                                      }}</span>
                                    </v-col>
                                    <v-col cols="2">
                                      <span class="caption font-weight-bold">{{
                                        totalImporteSaldo(item.detalle)
                                          | currency
                                      }}</span>
                                    </v-col>

                                    <v-col cols="1">
                                      <span class="caption"></span>
                                    </v-col>
                                  </v-row>

                                  <v-row align="center">
                                    <v-col cols="3">
                                      <v-switch
                                        v-model="modoExcepcion"
                                        label="Excepción"
                                      ></v-switch>
                                    </v-col>
                                    <v-col cols="2" v-if="!modoExcepcion">
                                      <v-text-field
                                        label="Total a Aplicar"
                                        v-model="totalAplicarCuota"
                                        v-on:keyup="
                                          totalAAplicarKeyUp($event, item)
                                        "
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="2" v-if="modoExcepcion">
                                      <v-text-field
                                        label="Aplicar a Cuota"
                                        v-model="totalAplicarCuota"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="2" v-if="modoExcepcion">
                                      <v-text-field
                                        label="Aplicar a Punit."
                                        v-model="totalAplicarPunitorios"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="2" v-if="modoExcepcion">
                                      <v-text-field
                                        label="Aplicar a Cargos"
                                        v-model="totalAplicarCargos"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col
                                      v-if="
                                        (modoExcepcion &&
                                          totalAplicarCuota +
                                            totalAplicarPunitorios +
                                            totalAplicarCargos >
                                            0) ||
                                          (!modoExcepcion &&
                                            totalAplicarCuota > 0)
                                      "
                                    >
                                      <v-btn
                                        color="green"
                                        fab
                                        x-small
                                        @click="
                                          agregarCuotasPorMonto(
                                            item.id,
                                            'Acuerdo'
                                          )
                                        "
                                      >
                                        <v-icon>add</v-icon></v-btn
                                      >
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-container>
                          </v-col>
                        </v-row>
                        <v-row dense> &nbsp; </v-row>
                        <v-divider pa-6></v-divider>
                      </v-container>
                    </v-row>
                  </template>
                </v-container>

                <!-- otros cargos por cobrar -->
                <v-container fluid v-if="listOtrosCargosPorCobrar.length > 0">
                  <!-- <v-row dense>
                                    <v-col>
                                        <span class="title"> Otros Cargos por Cobrar</span>
                                    </v-col>
                                </v-row> -->

                  <v-row dense class="body-2">
                    <v-col> Otros Cargos </v-col>
                    <v-col> Importe </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <template v-for="(item, index) in listOtrosCargosPorCobrar">
                    <v-row :key="index" dense class="ml-1">
                      <v-row class="caption" dense>
                        <v-col>
                          {{ item.tipo }} Nº {{ item.numero }}, de
                          {{ item.origen }}
                        </v-col>
                        <v-col>
                          {{ item.importe | currency }}
                        </v-col>
                        <v-col>
                          <v-btn
                            small
                            text
                            color="green"
                            @click="pagarTotalOtrasDeudas(item)"
                          >
                            Pagar la Totalidad
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-row>
                  </template>
                </v-container>
              </v-card>
            </v-col>

            <v-col>
              <v-card>
                <v-card-title>
                  <span class="title">Conceptos a Pagar</span>
                </v-card-title>
                <v-card-text>
                  <v-row class="caption" no-gutters>
                    <v-col cols="9" class="font-weight-bold">Detalle</v-col>
                    <v-col cols="2" class="text-right font-weight-bold"
                      >Importe</v-col
                    >
                    <v-col cols="1" class="text-right font-weight-bold"></v-col>
                  </v-row>
                  <template v-for="(item, index) in listDeudasAPagar">
                    <v-row class="caption" no-gutters :key="index">
                      <v-col cols="8">
                        <span
                          v-if="
                            item.tipo == 'Credito' &&
                              !item.item.numero.includes('Nota')
                          "
                          class="caption"
                          >- Cta. Nº {{ item.item.cuota }}, del Cred. Nº
                          <span class="font-italic font-weight-medium">
                            {{ item.numero }}
                          </span></span
                        >
                        <span
                          v-if="
                            item.tipo == 'Credito' &&
                              item.item.numero.includes('Nota')
                          "
                          class="caption"
                          >- ND Cta. Nº {{ item.item.cuota }}, del Cred. Nº
                          <span class="font-italic font-weight-medium">
                            {{ item.numero }}
                          </span></span
                        >
                        <span v-if="item.tipo == 'Acuerdo'" class="caption"
                          >- Cta. Acuerdo {{ item.item.cuota }}</span
                        >
                        <span v-else class="caption"
                          >- {{ item.tipo }} Nº {{ item.numero }}</span
                        >
                      </v-col>
                      <v-col cols="3"
                        ><div class="text-right">
                          {{ item.total | currency }}
                        </div></v-col
                      >
                      <v-col cols="1"
                        ><div class="text-right">
                          <v-icon
                            color="red"
                            small
                            @click="quitarConceptoPago(item)"
                            >clear</v-icon
                          >
                        </div></v-col
                      >
                    </v-row>
                  </template>
                  <v-divider></v-divider>
                  <v-row class="caption" no-gutters>
                    <v-col cols="8" class="text-center font-weight-bold"
                      >TOTAL</v-col
                    >
                    <v-col cols="3" class="text-right font-weight-bold">{{
                      totalAPagar | currency
                    }}</v-col>
                    <v-col cols="1" class="text-right font-weight-bold"></v-col>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="listDeudasAPagar.length > 0"
                    color="green"
                    small
                    dark
                    @click="confirmarCobranza"
                    >Proceder con el Pago
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

      <!-- egreso -->
      <v-container fluid v-if="accion == 'egreso'">
        <v-card>
          <v-card-title>
            <span class="title">Desembolso de Crédito</span>
          </v-card-title>

          <v-row>
            <v-col cols="8">
              <v-card>
                <v-card-title>
                  <span v-if="!loadingDeudas">Créditos por Liquidar</span>
                  <span v-if="loadingDeudas" class="green--text">
                    (Consultando Créditos por Liquidar de la Persona...
                    <v-progress-circular
                      indeterminate
                      size="24"
                      color="green"
                    ></v-progress-circular
                    >)</span
                  >
                </v-card-title>

                <!-- créditos por liquidar -->
                <v-container fluid v-if="listCreditosPorLiquidar.length > 0">
                  <template v-for="(item, index) in listCreditosPorLiquidar">
                    <v-row :key="index">
                      <v-container>
                        <v-card>
                          <v-card-text>
                            <v-row dense>
                              <v-col>
                                <span
                                  class="caption blue--text font-weight-medium"
                                  >Detalle del Crédito Nº
                                  {{ item.numero }}</span
                                >
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="3">
                                <span class="caption">Importe Solicitado</span>
                              </v-col>
                              <v-col>
                                <span class="font-weight-medium">{{
                                  item.monto | currency
                                }}</span>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="3">
                                <span class="caption"
                                  >Descuentos por Refinanciación</span
                                >
                              </v-col>
                              <v-col>
                                <span class="font-weight-medium">{{
                                  item.importeRefinanciaciones | currency
                                }}</span>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="3">
                                <span class="caption"
                                  >Descuentos por Cargos del Plan
                                </span>
                              </v-col>
                              <v-col>
                                <span class="font-weight-medium">{{
                                  item.cargosDescuento | currency
                                }}</span>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row dense>
                              <v-col cols="3">
                                <span class="caption">TOTAL a LIQUIDAR </span>
                              </v-col>
                              <v-col>
                                <span class="font-weight-black">{{
                                  item.importeALiquidar | currency
                                }}</span>
                              </v-col>
                              <v-col cols="3">
                                <v-btn
                                  color="success"
                                  small
                                  dark
                                  @click="confirmarEgreso(item)"
                                  :disabled="!item.puedeLiquidar"
                                  >Proceder a Desembolso</v-btn
                                >
                              </v-col>
                            </v-row>

                            <v-row dense>
                              <v-col v-if="!item.puedeLiquidar">
                                <v-chip class="caption" color="error"
                                  >NO SE PUEDE LIQUIDAR POR CAJA:
                                  {{ item.motivoNoPuedeLiquidar }}
                                </v-chip>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-container>
                    </v-row>
                  </template>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-card>

    <!-- deudas por cobrar no disponibles -->
    <v-dialog v-model="showDeudasNoDisponibles" width="800">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Deudas que no se puden Cobrar</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <v-row class="body-1" dense>
            <v-col cols="8"> Descripción </v-col>
            <v-col cols="4"> Motivo </v-col>
          </v-row>
          <v-list>
            <v-list-item v-for="item in listDeudasNoPuedeCobrar" :key="item.id">
              <template v-if="item.tipo == 'Credito'">
                <v-row class="body-2" dense>
                  <v-col cols="8">
                    Crédito Nº {{ item.numero }}, de {{ item.origen }}
                  </v-col>
                  <v-col cols="4">
                    {{ item.motivoNoPuedeCobrar }}
                  </v-col>
                </v-row>
              </template>
              <template v-if="item.tipo == 'Acuerdo'">
                <v-row class="body-2" dense>
                  <v-col cols="8"> Acuerdo de Pago </v-col>
                  <v-col cols="4">
                    {{ item.motivoNoPuedeCobrar }}
                  </v-col>
                </v-row>
              </template>
              <template v-if="item.tipo == 'NotaDebito'">
                <v-row class="body-2" dense>
                  <v-col cols="8">
                    {{ item.tipo }} Nº {{ item.numero }}, de {{ item.origen }}
                  </v-col>
                  <v-col cols="4">
                    {{ item.motivoNoPuedeCobrar }}
                  </v-col>
                </v-row>
              </template>
              <template v-if="item.tipo == 'CuotaClub'">
                <v-row class="body-2" dense>
                  <v-col cols="8">
                    Cuota Club {{ item.tipo }} Nº {{ item.numero }}, de
                    {{ item.origen }}
                  </v-col>
                  <v-col cols="4">
                    {{ item.motivoNoPuedeCobrar }}
                  </v-col>
                </v-row>
              </template>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- deudas acuerdo -->
    <v-dialog v-model="showDeudasAcuerdo" width="800">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Deudas incluidas en el Acuerdo de Pago</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <v-row class="body-1" dense>
            <v-col> Descripción </v-col>
          </v-row>
          <v-list>
            <v-list-item v-for="item in listDeudasAcuerdo" :key="item.id">
              <template v-if="item.tipoDeudaId == 1">
                <v-row class="body-2" dense>
                  <v-col>
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresa
                    }}</v-chip>
                    Crédito {{ item.numero }}, de {{ item.origen }}
                  </v-col>
                </v-row>
              </template>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- configuracion tickeadora -->
    <v-dialog v-model="showConfigTickeadora" width="800">
      <app-configuracion-tickeadora></app-configuracion-tickeadora>
    </v-dialog>

    <!-- alertas -->
    <v-dialog v-model="showAlertas" width="500">
      <app-alertas
        :Lista="selectedPersona == null ? null : selectedPersona.alertas"
        @close-dialog="showAlertas = false"
      >
      </app-alertas>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { format } from 'date-fns';
import axios from 'axios';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data: () => ({
    loading: false,
    loadingDeudas: false,
    showDeudasNoDisponibles: false,
    showDeudasAcuerdo: false,
    showConfigTickeadora: false,
    accion: '',
    cajaId: null,
    fechaCaja: null,
    headersMovimientosDia: [
      // definición de columnas
      { text: 'Concepto', value: 'concepto' },
      { text: 'Importe', value: 'importe', width: 140 },
      { text: 'Info', value: 'info' },
      { text: 'Transacción Id', value: 'transaccion', width: 120 },
    ],
    pagination: {
      // definición de paginación
      sortDesc: [true],
      sortBy: [''],
      page: 1,
      itemsPerPage: 10,
    },
    totalItems: 0, // va afuera de pagination
    listCajas: [],
    listMonedas: [],
    listMovimientosDia: [],
    listDeudasPorCobrar: [],
    listDeudasAPagar: [],
    listDeudasAcuerdo: [],
    listCreditosPorLiquidar: [],
    selectedPersona: null,
    personaId: '',
    modoExcepcion: false,
    showDetalleCredito: false,
    creditoSeleccionadoId: null,
    totalAplicarCuota: null,
    totalAplicarPunitorios: null,
    totalAplicarCargos: null,
    showSelectorCajas: true,
    abrirOtraFecha: false,
    modoAnulacion: false,
    modoReimpresion: false,
    localConfig: null,
    apiSerialPrintValidada: false,
    showMovimientosMonedaExtranjera: false,
    listWatchers: [],
    filtroComentariosMovimiento: '',
    showAlertas: false,
    enEstudio: false,
    modificarFechaValor: false,
    fechaProceso: null,
    formatosEnvioDebitoId: null,
  }),
  async created() {
    this.fechaCaja = this.$moment().startOf('day');

    await this.loadLocalConfig();
    await this.loadCajas();
    await this.loadMonedas();
  },
  watch: {
    pagination: {
      async handler() {
        console.log('pagination handler');
        await this.loadMovimientosDelDia();
      },
      deep: true,
    },
    modoExcepcion: {
      handler() {
        if (this.modoExcepcion) {
          this.totalAplicarCuota = 0;
          this.totalAplicarPunitorios = 0;
          this.totalAplicarCargos = 0;
        }
      },
    },
    filtroComentariosMovimiento() {
      this.loadMovimientosDelDia();
    },
    fechaProceso() {
      this.loadDeudasPorCobrar();
    },
    modificarFechaValor() {
      if (!this.modificarFechaValor) {
        this.fechaProceso = null;
      }
    },
    // cajaId:{
    //     async handler(){
    //         if(this.cajaId > 0 && !this.showSelectorCajas){
    //             console.log('cajaId handler')
    //             await this.prepararMovimientosDelDia();
    //             await this.loadMovimientosDelDia();
    //         }
    //     },
    // }
  },
  computed: {
    ...mapGetters([
      'user',
      'UiCustomUserSettings',
      'DebugModeOn',
      'getActionFromLink',
      'checkCanAccess',
    ]),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
    cajaAbierta: function() {
      return this.selectedCaja ? this.selectedCaja.estaAbierta : false;
    },
    showSelector: function() {
      return (
        !this.selectedCaja || !this.selectedCaja.id || this.showSelectorCajas
      );
    },
    selectedCaja: function() {
      if (!this.cajaId || this.cajaId == 0) return { estaAbierta: false };
      return this.listCajas.find((c) => c.id == this.cajaId);
    },
    pages() {
      if (this.pagination.rowsPerPage == null || this.totalItems == null)
        return 0;

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },
    listCreditosPorCobrar: function() {
      if (!this.listDeudasPorCobrar || this.listDeudasPorCobrar.length == 0)
        return [];
      let lista = this.listDeudasPorCobrar.filter(
        (i) => i.tipo == 'Credito' && i.puedeCobrarUsuario
      );

      return lista;
    },
    listAcuerdosPorCobrar: function() {
      if (!this.listDeudasPorCobrar || this.listDeudasPorCobrar.length == 0)
        return [];
      let lista = this.listDeudasPorCobrar.filter(
        (i) => i.tipo == 'Acuerdo' && i.puedeCobrarUsuario
      );

      return lista;
    },
    listOtrosCargosPorCobrar: function() {
      if (!this.listDeudasPorCobrar || this.listDeudasPorCobrar.length == 0)
        return [];
      let lista = this.listDeudasPorCobrar.filter(
        (i) =>
          (i.tipo == 'NotaDebito' || i.tipo == 'CuotaClub') &&
          i.puedeCobrarUsuario
      );
      return lista;
    },
    listDeudasNoPuedeCobrar: function() {
      if (!this.listDeudasPorCobrar || this.listDeudasPorCobrar.length == 0)
        return [];
      let lista = this.listDeudasPorCobrar.filter((i) => !i.puedeCobrarUsuario);

      return lista;
    },
    totalAPagar: function() {
      if (!this.listDeudasAPagar || this.listDeudasAPagar.length == 0) return 0;

      var total = 0;
      for (let index = 0; index < this.listDeudasAPagar.length; index++) {
        total = total + parseFloat(this.listDeudasAPagar[index].total);
      }
      return total;
    },
    sinConfiguracionLocal: function() {
      return !this.localConfig || this.localConfig.cajaId == 0;
    },
    apiSerialPrintConfigurada: function() {
      return (
        this.localConfig &&
        this.localConfig.usarTickeadora &&
        this.localConfig.apiSerialPrint != '' &&
        this.localConfig.port != ''
      );
    },
    cambiarFechaCaja: function() {
      return this.checkCanAccess('ap-cambiar_fecha-caja');
    },
    anularMovimiento: function() {
      return this.checkCanAccess('ap-anulacion-movimiento-caja');
    },
    puedeModificarFechaValor: function() {
      return this.checkCanAccess('ap-modifica-fecha-proceso');
    },
    puedeAltaNuevoCargo: function() {
      return this.checkCanAccess('ap-alta-cargo-encaja');
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'hideActiveTask',
      'setActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    searchValueKeyUp: function(e) {
      if (e.keyCode === 13) {
        this.search();
      }
    },
    async seleccionarCaja() {
      await this.prepararMovimientosDelDia();
      await this.loadMovimientosDelDia();
    },
    async abrirCaja(abrirParaHoy) {
      var caja = this.listCajas.find((c) => c.id == this.cajaId);

      if (abrirParaHoy) this.fechaCaja = this.$moment().startOf('day');

      var params = {
        cajaId: caja.id,
        fecha: this.fechaCaja,
      };

      this.loading = true;
      try {
        var result = await http.post('cajas/abrircaja', JSON.stringify(params));

        if (result.seCambio) {
          this.alertSuccess('La Caja ha sido abierta');

          await this.loadCajas(); // recargo los estados de las cajas
          this.showSelectorCajas = false;
          this.abrirOtraFecha = false;
          this.seleccionarCaja();
        } else {
          this.alertWarning(result.motivo);
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async cerrarCaja() {
      var caja = this.listCajas.find((c) => c.id == this.cajaId);

      var params = {
        width: 500,
        temporary: true,
        caja: caja,
        accionCompleta: this.cierreConfirmado,
      };

      this.setActiveTask({ task: 'app-cierre-caja', props: params });
    },
    async listadosCaja(temp) {
      var caja = this.listCajas.find((c) => c.id == this.cajaId);

      var params = {
        width: 500,
        temporary: temp,
        caja: caja,
      };

      await this.setActiveTask({ task: 'app-listados-caja', props: params });
    },
    async anular(item) {
      var caja = this.listCajas.find((c) => c.id == this.cajaId);

      var params = {
        width: 500,
        temporary: true,
        caja: caja,
        transaccionId: item.transaccionId,
        concepto: item.concepto,
        importe: item.importe,
        info: item.info,
        accionCompleta: this.loadMovimientosDelDia,
      };

      await this.setActiveTask({
        task: 'app-anular-movimiento-caja',
        props: params,
      });
    },
    async imprimir(item) {
      var caja = this.listCajas.find((c) => c.id == this.cajaId);

      var params = {
        width: 600,
        temporary: true,
        caja: caja,
        transaccionId: item.transaccionId,
      };

      await this.setActiveTask({
        task: 'app-impresion-comprobante',
        props: params,
      });
    },
    async cierreConfirmado() {
      await this.loadCajas(); // recargo los estados de las cajas
      this.showSelectorCajas = true;
    },
    async cambiarCaja() {
      await this.loadCajas();
      this.showSelectorCajas = true;
      this.modoAnulacion = false;
      this.modoReimpresion = false;
      this.accion = '';
      this.resetearDatosCliente();
    },
    async resetearDatosCliente() {
      this.selectedPersona = null;
      this.personaId = '';
      this.listDeudasPorCobrar = [];
      this.listDeudasAPagar = [];
      this.listDeudasAcuerdo = [];
      this.listCreditosPorLiquidar = [];
      this.enEstudio = false;
      this.modoExcepcion = false;
      this.showDetalleCredito = false;
      this.creditoSeleccionadoId = null;
      this.totalAplicarCuota = null;
      this.totalAplicarPunitorios = null;
      this.totalAplicarCargos = null;
    },
    altaMovimientoPuntual() {
      var params = {
        width: 500,
        cajaId: this.selectedCaja.id,
        cajaMultiMoneda: this.selectedCaja.multiMoneda,
        fechaCaja: this.selectedCaja.abiertaEl,
        accionCompleta: this.loadMovimientosDelDia,
      };

      this.setActiveTask({
        task: 'app-alta-movimiento-puntual-caja',
        props: params,
      });
    },
    limpiar: function() {
      this.selectedPersona = null;
      this.accion = null;
      this.listDeudasPorCobrar = [];
      this.listDeudasAPagar = [];
    },
    totalImporteCuotas: function(items) {
      if (!items) return 0;

      var total = 0;
      for (let index = 0; index < items.length; index++) {
        total = total + parseFloat(items[index].importeCuota);
      }
      return total;
    },
    totalImportePunitorios: function(items) {
      if (!items) return 0;

      var total = 0;
      for (let index = 0; index < items.length; index++) {
        total = total + parseFloat(items[index].importePunitorios);
      }
      return total;
    },
    totalImporteCargos: function(items) {
      if (!items) return 0;

      var total = 0;
      for (let index = 0; index < items.length; index++) {
        total = total + parseFloat(items[index].importeCargos);
      }
      return total;
    },
    totalImporteSaldo: function(items) {
      if (!items) return 0;

      var total = 0;
      for (let index = 0; index < items.length; index++) {
        total = total + parseFloat(items[index].importeTotal);
      }
      return total;
    },
    async prepararMovimientosDelDia() {
      this.listMovimientosDia = [];

      for (let index = 0; index < this.listWatchers.length; index++) {
        const unwatcher = this.listWatchers[index];
        unwatcher();
      }
      this.listWatchers = [];

      if (!this.selectedCaja.multiMoneda) {
        var moneda = this.listMonedas.find((m) => m.predeterminada);

        // solo moneda predeterminada
        var item = {
          totalItems: 0,
          listMovimientosDia: [],
          moneda: moneda,
          pagination: {
            // definición de paginación
            sortDesc: [true],
            sortBy: [''],
            page: 1,
            itemsPerPage: 10,
          },
        };

        this.listMovimientosDia.push(item);
      } else {
        // un item por cada moneda definida
        for (let i = 0; i < this.listMonedas.length; i++) {
          const moneda = this.listMonedas[i];

          var item = {
            totalItems: 0,
            listMovimientosDia: [],
            moneda: moneda,
            pagination: {
              // definición de paginación
              sortDesc: [true],
              sortBy: [''],
              page: 1,
              itemsPerPage: 10,
            },
          };

          this.listMovimientosDia.push(item);
        }
      }

      // preparo el watcher
      for (let index in this.listMovimientosDia) {
        var unwatch = this.$watch(
          ['listMovimientosDia', index, 'pagination'].join('.'),
          (newVal, oldVal) => {
            console.info(
              'listMovimientosDia',
              this.listMovimientosDia[index],
              newVal,
              oldVal
            );
            this.reloadMovimientos(this.listMovimientosDia[index]);
          }
        );
        this.listWatchers.push(unwatch);
      }
    },
    async reloadMovimientos(item) {
      var res = await this.loadMovimientosDelDiaPorMoneda(item);

      item.totalItems = res.totalItems;
      item.listMovimientosDia = res.listMovimientosDia;
    },
    async loadMovimientosDelDia() {
      if (this.selectedCaja == null) return;

      this.loading = true;

      console.log(this.listMovimientosDia);

      // recorro las monedas habilitadas para la caja y cargo los movimientos del dia x cada moneda
      for (let i = 0; i < this.listMovimientosDia.length; i++) {
        const item = this.listMovimientosDia[i];
        var res = await this.loadMovimientosDelDiaPorMoneda(item);

        item.totalItems = res.totalItems;
        item.listMovimientosDia = res.listMovimientosDia;
      }

      this.loading = false;
    },
    async loadMovimientosDelDiaPorMoneda(item) {
      var moneda = this.listMonedas.find((m) => m.id == item.moneda.id);

      var res = { totalItems: 0, listMovimientosDia: [] };

      try {
        var result = await http.get(
          'cajas/listmovimientos' +
            '?cajaId=' +
            this.cajaId +
            '&monedaId=' +
            moneda.id +
            '&fechaDesde=' +
            this.$moment(this.fechaCaja).format('YYYY-MM-DD') +
            '&fechaHasta=' +
            this.$moment(this.fechaCaja).format('YYYY-MM-DD') +
            '&comentarios=' +
            this.filtroComentariosMovimiento +
            '&incluirAnulados=false' +
            '&limit=' +
            item.pagination.itemsPerPage +
            '&page=' +
            item.pagination.page
        );

        res.listMovimientosDia = result.list;
        res.totalItems = result.totalCount;

        return res;
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
    async loadDeudasPorCobrar() {
      this.listDeudasPorCobrar = [];
      this.loadingDeudas = true;
      try {
        let fechaConsulta = this.fechaCaja;
        console.log(this.fechaProceso);
        if (this.modificarFechaValor) fechaConsulta = this.fechaProceso;

        var result = await http.get(
          'personas/listdeudasporcobrar' +
            '?empresaId=' +
            this.selectedCaja.empresaId +
            '&id=' +
            this.personaId +
            '&fechaCaja=' +
            this.$moment(fechaConsulta).format('YYYY-MM-DD')
        );

        this.listDeudasPorCobrar = result.list;
        //console.log(this.listDeudasPorCobrar)
        this.loadTieneEstudio();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingDeudas = false;
    },
    async loadTieneEstudio() {
      try {
        var result = await http.get(
          'creditos/listporpersona' +
            '?personaId=' +
            this.personaId +
            '&fechaCalculo=' +
            this.$moment().format('L') +
            '&sortBy='
        );

        for (let i = 0; i < result.list.length; i++) {
          if (result.list[i].subEstadoDescripcion.includes('Estudio')) {
            this.enEstudio = true;
          } else {
            this.enEstudio = false;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadDeudasAcuerdo(item) {
      this.listDeudasAcuerdo = [];
      this.loading = true;
      try {
        var result = await http.get(
          'acuerdos/listdeudas' + '?acuerdoId=' + item.id
        );

        this.listDeudasAcuerdo = result.list;
        console.log(this.listDeudasAcuerdo);
        this.showDeudasAcuerdo = true;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCreditosPorLiquidar() {
      this.listCreditosPorLiquidar = [];
      this.loadingDeudas = true;
      try {
        var result = await http.get(
          'personas/listcreditosporliquidar' +
            '?empresaId=0' +
            '&id=' +
            this.personaId
        );

        this.listCreditosPorLiquidar = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingDeudas = false;
    },
    isExpandedDetalleCredito: function(item) {
      if (!item || !this.creditoSeleccionadoId || !this.showDetalleCredito)
        return false;

      if (item.id == this.creditoSeleccionadoId) return true;
      else return false;
    },
    pagarTotalDeudaCredito(item) {
      // agrego el total de deuda hasta el día
      for (let index = 0; index < item.detalle.length; index++) {
        const el = item.detalle[index];

        if (el.incluirEnDeudaALaFecha == true) {
          // veo que ya no esté incluido
          if (
            this.listDeudasAPagar.find(
              (i) => i.cuotaId == el.id && i.notaDebitoId == el.notaDebitoId
            ) != null
          )
            continue;

          this.addConceptoAPagar(
            item.tipo,
            item.id,
            item.numero,
            el,
            el.importeCuota,
            el.importePunitorios,
            el.importeCargos
          );
        }
      }
      this.showDetalleCredito = false;
    },
    pagarTotalOtrasDeudas(item) {
      // agrego el total de deuda
      for (let index = 0; index < item.detalle.length; index++) {
        const el = item.detalle[index];

        if (el.incluirEnDeudaALaFecha == true) {
          // veo que ya no esté incluido
          if (this.listDeudasAPagar.find((i) => i.cuotaId == el.id) != null)
            continue;

          this.addConceptoAPagar(
            item.tipo,
            item.id,
            item.numero,
            el,
            el.importeCuota,
            el.importePunitorios,
            el.importeCargos
          );
        }
      }
    },
    agregarCuotaCredito(creditoId, item) {
      // agrego hasta la cuota seleccionada mas todas las anteriores (que tengan saldo de cuota)
      var listaAAgregar = this.listCreditosPorCobrar
        .find((d) => d.id == creditoId)
        .detalle.filter(
          (i) =>
            (i.cuota <= item.cuota && i.importeCuota > 0) ||
            (i.cuota == item.cuota && i.importeCuota == 0)
        );

      console.log(this.listCreditosPorCobrar);
      console.log(listaAAgregar);

      var credito = this.listCreditosPorCobrar.find((d) => d.id == creditoId);

      for (let index = 0; index < listaAAgregar.length; index++) {
        const el = listaAAgregar[index];

        // veo que ya no esté incluido
        if (
          this.listDeudasAPagar.find(
            (i) => i.cuotaId == el.id && i.notaDebitoId == el.notaDebitoId
          ) != null
        )
          continue;

        this.addConceptoAPagar(
          'Credito',
          creditoId,
          credito.numero,
          el,
          el.importeCuota,
          el.importePunitorios,
          el.importeCargos
        );
      }
    },
    agregarCuotaAcuerdo(creditoId, item) {
      // agrego hasta la cuota seleccionada mas todas las anteriores
      var listaAAgregar = this.listAcuerdosPorCobrar
        .find((d) => d.id == creditoId)
        .detalle.filter((i) => i.cuota <= item.cuota);

      var credito = this.listAcuerdosPorCobrar.find((d) => d.id == creditoId);

      for (let index = 0; index < listaAAgregar.length; index++) {
        const el = listaAAgregar[index];

        // veo que ya no esté incluido
        if (
          this.listDeudasAPagar.find(
            (i) => i.cuotaId == el.id && i.notaDebitoId == el.notaDebitoId
          ) != null
        )
          continue;

        this.addConceptoAPagar(
          'Acuerdo',
          creditoId,
          credito.numero,
          el,
          el.importeCuota,
          el.importePunitorios,
          el.importeCargos
        );
      }
    },
    async agregarCuotasPorMonto(creditoId, tipo) {
      // al agregar x monto, quito los conceptos que pueda haber anteriormente para el crédito
      var listaCuotasABorrar = this.listDeudasAPagar.filter(
        (d) => d.id == creditoId
      );
      if (listaCuotasABorrar.length > 0)
        this.quitarConceptoPago(listaCuotasABorrar[0]);

      var porAplicarACuota;
      var porAplicarAPunitorios;
      var porAplicarACargos;

      if (!this.modoExcepcion) {
        porAplicarACuota = parseFloat(this.totalAplicarCuota);
        porAplicarAPunitorios = 0;
        porAplicarACargos = 0;
      } else {
        porAplicarACuota = parseFloat(this.totalAplicarCuota);
        porAplicarAPunitorios = parseFloat(this.totalAplicarPunitorios);
        porAplicarACargos = parseFloat(this.totalAplicarCargos);
      }

      var credito;
      var cuotas;
      if (tipo == 'Credito') {
        credito = this.listCreditosPorCobrar.find((d) => d.id == creditoId);
        cuotas = this.listCreditosPorCobrar.find((d) => d.id == creditoId)
          .detalle;
      } else if (tipo == 'Acuerdo') {
        credito = this.listAcuerdosPorCobrar.find((d) => d.id == creditoId);
        cuotas = this.listAcuerdosPorCobrar.find((d) => d.id == creditoId)
          .detalle;
      }

      this.loading = true;
      try {
        var result = await http.put(
          'businesscore/distribuirpagoacuotascredito',
          JSON.stringify({
            modoExcepcion: this.modoExcepcion,
            importeAAplicarCuota: porAplicarACuota,
            importeAAplicarPunitorios: porAplicarAPunitorios,
            importeAAplicarCargos: porAplicarACargos,
            cuotasAdeudadas: cuotas,
          })
        );

        //console.log(result)
        if (result.length > 0) {
          for (let index = 0; index < result.length; index++) {
            const el = result[index];
            const item = cuotas.find(
              (c) => c.id == el.id && c.notaDebitoId == el.notaDebitoId
            );

            this.addConceptoAPagar(
              tipo,
              credito.id,
              credito.numero,
              item,
              el.importeAplicadoCuota,
              el.importeAplicadoPunitorios,
              el.importeAplicadoCargos
            );
          }

          // limpio
          this.totalAplicarCuota = null;
          this.totalAplicarPunitorios = null;
          this.totalAplicarCargos = null;

          this.showDetalleCredito = false;
        } else {
          this.alertWarning(
            'No se pudo distribuir el monto ingresado entre los conceptos adeudados. Verfique'
          );
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    addConceptoAPagar(
      tipo,
      id,
      numero,
      item,
      aplicaCuota,
      aplicaPunitorios,
      aplicaCargos
    ) {
      var toAdd = {};
      toAdd.tipo = tipo;
      toAdd.numero = numero;
      toAdd.id = id;
      toAdd.cuotaId = item.id;
      toAdd.notaDebitoId = item.notaDebitoId;
      toAdd.item = item;
      toAdd.importeAAplicarACuota = aplicaCuota;
      toAdd.importeAAplicarAPunitorios = aplicaPunitorios;
      toAdd.importeAAplicarACargos = aplicaCargos;
      toAdd.total =
        parseFloat(toAdd.importeAAplicarACuota) +
        parseFloat(toAdd.importeAAplicarAPunitorios) +
        parseFloat(toAdd.importeAAplicarACargos);
      toAdd.ImporteAAplicar =
        parseFloat(toAdd.importeAAplicarACuota) +
        parseFloat(toAdd.importeAAplicarAPunitorios) +
        parseFloat(toAdd.importeAAplicarACargos);
      console.log(toAdd);
      this.listDeudasAPagar.push(toAdd);
    },
    quitarConceptoPago(item) {
      // si el concepto es de una cuota de crédito o acuerdo, quito de la seleccinada para adelante
      if (item.tipo == 'Credito' || item.tipo == 'Acuerdo') {
        var listaAQuitar = this.listDeudasAPagar.filter(
          (d) => d.id == item.id && d.item.cuota >= item.item.cuota
        );
        var indexToRemove = this.listDeudasAPagar.indexOf(item);

        this.listDeudasAPagar.splice(indexToRemove, listaAQuitar.length);
      } else {
        var indexToRemove = this.listDeudasAPagar.indexOf(item);
        this.listDeudasAPagar.splice(indexToRemove, 1);
      }
    },
    async confirmarCobranza(item) {

      var params = {
        width: 500,
        temporary: true,
        cajaId: this.cajaId,
        cajaMultiMoneda: this.selectedCaja.multiMoneda,
        requiereBancoAcreditacion: this.selectedCaja.requiereBancoAcreditacion,
        fechaCaja: this.fechaCaja,
        fechaProceso: this.fechaProceso,
        personaId: this.personaId,
        bancoacreditacionId: this.bancoacreditacionId,
        detalleCobranza: this.listDeudasAPagar,
        accionConfirmada: this.cobranzaRealizada,
        //DYLAN metodo
        formatoEnvioDebitoId: this.listCajas.find(
          (caja) => caja.id === this.cajaId
        ).formatosEnvioDebitoId,
      };
      //Para ver valores
      console.log(
        'Propiedad formatoEnvioDebitoId LAYOUT:',
        this.formatosEnvioDebitoId
      ),
        console.log('Propiedad CAJAId LAYOUTTT:', this.cajaId),
        this.setActiveTask({ task: 'app-confirmar-cobranza', props: params });
    },

    async cobranzaRealizada(resultado) {
      await this.hideActiveTask();

      // abro la pantalla de impresión
      var transaccion = resultado.find((i) => i.tipo == 'Transaccion');

      // console.log('TR')
      // console.log(resultado)
      // console.log(transaccion)
      if (transaccion) {
        await this.imprimir({ transaccionId: transaccion.id });
      }

      this.limpiar();
      this.loadMovimientosDelDia(); // refresco los movimientos del día
    },
    async confirmarEgreso(item) {
      var params = {
        width: 500,
        temporary: true,
        cajaId: this.cajaId,
        fechaCaja: this.fechaCaja,
        personaId: this.personaId,
        credito: item,
        accionConfirmada: this.egresoRealizado,
      };

      this.setActiveTask({ task: 'app-confirmar-egreso', props: params });
    },
    egresoRealizado() {
      this.limpiar();
      this.loadMovimientosDelDia(); // refresco los movimientos del día
    },
    setPersona(persona) {
      this.selectedPersona = persona;
      this.personaId = persona.personaId;
    },
    altaCargo() {
      var params = {
        width: 900,
        visible: true,
        persona: this.selectedPersona,
      };

      console.log(JSON.stringify(params));

      this.setActiveTask({ task: 'app-alta-cargos', props: params });
    },
    totalAAplicarKeyUp: function(e, item) {
      if (e.keyCode === 13) {
        this.agregarCuotasPorMonto(item.id, item.tipo);
      }
    },
    async loadCajas() {
      this.listCajas = [];
      this.loading = true;
      try {
        var result = await http.get(
          'cajas/disponiblesporusuario?login=' + this.user.login
        );
        this.listCajas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMonedas() {
      this.listMonedas = [];
      this.loading = true;
      try {
        var result = await http.get('monedas');
        this.listMonedas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadLocalConfig() {
      var config = localStorage.getItem('localconfig');
      if (config != null) {
        this.localConfig = JSON.parse(config);

        if (this.localConfig.cajaId != 0) this.cajaId = this.localConfig.cajaId;

        if (this.apiSerialPrintConfigurada) {
          this.validarApiSerialPrint();
        }
      }
    },
    async validarApiSerialPrint() {
      var self = this;

      const instance = axios.create({
        baseURL: this.localConfig.apiSerialPrint,
        timeout: 1000,
        headers: { 'X-Custom-Header': 'foobar' },
      });

      instance
        .get('/itsalive')
        .then(function(response) {
          self.apiSerialPrintValidada = true;

          self.alertSuccess('Api de Impresión respondió correctamente');
        })
        .catch(function(error) {
          self.apiSerialPrintValidada = false;
          self.alertError('Error al validar la Api de Impresión: ' + error);
        });
    },
    imprimirReconocimientoPunitorios(item) {
      let params = [];
      params.push({
        CreditoId: item.id,
      });

      this.setReporteActivo({
        reporte: 'Formulario Reconocimiento Punitorios.trdp',
        params: params,
      });

      window.open('/report-viewer');
    },
    async print2com() {
      console.log('print2com');

      const instance = axios.create({
        baseURL: 'http://localhost:16990/api/',
        timeout: 1000,
        headers: { 'X-Custom-Header': 'foobar' },
      });

      instance
        .post('/values/sendtocom', {
          sendTo: 'COM1',
          text: 'Flintstone',
        })
        .then(function(response) {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async print() {
      console.log('print2com');

      const instance = axios.create({
        baseURL: this.localConfig.apiSerialPrint,
        timeout: 1000,
        headers: { 'X-Custom-Header': 'foobar' },
      });

      instance
        .post('/print', {
          sendTo: 'COM1',
          text: 'Flintstone',
        })
        .then(function(response) {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async copyTextToClipboard(text) {
      Vue.$log.debug('copian2');
      if (!navigator.clipboard) {
        Vue.$log.debug('no clipboard');
        //fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        function() {
          console.log('Async: Copying to clipboard was successful!');
        },
        function(err) {
          console.error('Async: Could not copy text: ', err);
        }
      );
    },
  },
};
</script>
